<template>
  <div v-if="$apollo.loading">Loading...</div>
  <q-page v-else padding>
    <h2 class="text-center">Voucher</h2>
    <q-checkbox :value="!!voucher.expired" label="Has Expired" :disabled="true" />
    <div class="col q-gutter-md">
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">
          <q-tooltip>
            The code the user can enter to get the discount.
          </q-tooltip>
          Code:
        </div>
        <div class="col-auto q-pl-md">
          {{voucher.voucherCode}}
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <q-btn size="xs" flat dense icon="content_copy" class="q-ml-sm" @click="copyVoucherCode"></q-btn>
          <m-popup-edit v-model="voucher.voucherCode"
                        @save="v => editVoucher({voucherCode: v})"/>
        </div>
      </div>
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">
          <q-tooltip>
            If this discount is applied to an order they will get this percentage off the items in their cart.<br/>
            Note discount is not applied to shipping.
          </q-tooltip>
          Percent Value:
        </div>
        <div class="col-auto q-pl-md">
          {{(voucher.percentValue || 0).toFixed(2)}}%
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit :value="(voucher.percentValue || 0).toFixed(2)"
                        @save="v => editVoucher({percentValue: Number(Number(v).toFixed(2))})"
                        input-type="number"
                        min="0"
                        max="5000" />
        </div>
      </div>
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">
          <q-tooltip>
            If this discount is applied to an order they will get this many dollars off the items in their cart.<br/>
            Note discount is not applied to shipping.  Also note that the value of the items cannot go negative.<br/>
            So the user will always pay shipping on the undiscounted cost of items.
          </q-tooltip>
          Dollar Value:
        </div>
        <div class="col-auto q-pl-md">
          ${{(voucher.dollarValue || 0).toFixed(2)}}
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit :value="(voucher.dollarValue || 0).toFixed(2)"
                        @save="v => editVoucher({dollarValue: Number(Number(v).toFixed(2))})"
                        input-type="number"
                        min="0"
                        max="5000" />
        </div>
      </div>
      <m-edit-item field="expiresAt" type="datetime" graphqlType="Voucher" :id="id" label="Voucher Expires At" />
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">
          <q-tooltip>
            The total dollar value of the discount given will be capped at this amount.<br/>
            So if you give a 10% discount and the 'Max Value Per Use' is set to $100 then if a user<br/>
            Made a $5000 order the total discount they would get would be $100, not $500.
          </q-tooltip>
          Maximum Value Per Use:
        </div>
        <div class="col-auto q-pl-md">
          ${{(voucher.maxDollarValue || 0).toFixed(2)}}
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit :value="(voucher.maxDollarValue || 0).toFixed(2)"
                        @save="v => editVoucher({maxDollarValue: Number(Number(v).toFixed(2))})"
                        input-type="number"
                        min="0"
                        max="5000" />
        </div>
      </div>
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">
          <q-tooltip>
            The number of times this voucher may be used before it 'expires'.<br/>
            This allows you to limit a voucher to only be used once (one off vouchers) or say 10 times.<br/>
          </q-tooltip>
          Allowed Usages
        </div>
        <div class="col-auto q-pl-md">
          {{(voucher.allowedUsages || 0).toFixed(0)}}
          <q-btn size="xs" flat dense icon="edit" class="q-ml-sm"></q-btn>
          <m-popup-edit :value="(voucher.allowedUsages || 0).toFixed(0)"
                        @save="v => editVoucher({allowedUsages: Number(Number(v).toFixed(0))})"
                        input-type="number"
                        min="0" />
        </div>
      </div>
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">Times Used:</div>
        <div class="col-auto q-pl-md">
          {{(voucher.timesUsed || 0).toFixed(0)}}
        </div>
      </div>
      <div class="row items-center">
        <div style="width: 8em; text-align: right;">
          <q-tooltip>
            The sum of all discounts given with this voucher.
          </q-tooltip>
          Total Discounts Given:
        </div>
        <div class="col-auto q-pl-md">
          ${{(voucher.totalDiscountsGiven || 0).toFixed(0)}}
        </div>
      </div>
<!--      <div class="row items-center">-->
<!--        <div style="width: 8em; text-align: right;">Orders Used On:</div>-->
<!--        <div class="col-auto q-pl-md">-->
<!--          TODO-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </q-page>
</template>

<script>
import MPopupEdit from '../../components/ui/MPopupEdit'
import gql from 'graphql-tag'
import MEditItem from '../../components/ui/admin/MEditItem'
import adminNotifyError from '../../util/adminNotifyError'
export default {
  name: 'PageAdminAccount',
  components: { MEditItem, MPopupEdit },
  apollo: {
    voucher () {
      return {
        query: gql`
          query voucher($id: ID!) {
            voucher(id: $id) {
              id
              voucherCode
              dollarValue
              percentValue
              maxDollarValue
              allowedUsages
              expiresAt
              timesUsed
              totalDiscountsGiven
              expired
              # createdAt,
              # verifiedAt
            }
          }
      `,
        variables: {
          id: this.$route.params.id
        }
      }
    }
  },
  methods: {
    copyVoucherCode (event) {
      event.stopPropagation()
      navigator.clipboard.writeText(this.voucher.voucherCode).then(() => {
        console.log('Async: Copying to clipboard was successful!')
        this.$q.notify({
          message: 'Copied code to clipboard.',
          color: 'positive',
          icon: 'done'
        })
      }, (err) => {
        console.error('Async: Could not copy text: ', err)
      })

    },
    editVoucher (input) {
      this.$apollo.mutate({
        mutation: gql`
            mutation editVoucher($id: ID!, $input: VoucherInput!) {
              editVoucher(id: $id, input: $input) {
                id
                voucherCode
                dollarValue
                percentValue
                maxDollarValue
                allowedUsages
                expiresAt
                timesUsed
                totalDiscountsGiven
                expired
                # createdAt,
                # verifiedAt
              }
            }
          `,
        variables: {
          id: this.$route.params.id,
          input
        }
      }).then(result => {
        // console.log(result)
      }).catch(err => {
        adminNotifyError(this.$q, 'Error Updating Voucher', err)
      })
    },
    updateVerified (val) {
      this.updateAccount({ verifiedAt: val })
    },
    checkUpdateVerified (val) {
      if (val) {
        this.updateVerified(new Date())
      } else {
        this.$q.dialog({
          title: 'Unverify Account',
          message: `Are you sure you want to unverify ${this.voucher.companyName}?`,
          cancel: true
        }).onOk(() => {
          this.updateVerified(null)
        })
      }
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    currentAccount () {
      return this.$store.state.auth.currentAccount
    }
  },
  data () {
    return {
    }
  }
}
</script>
